import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 资源中心 - 行业报告
  {
    path: '/report',
    component: () => import('../views/resourceCenter/report/report.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
    children: [
      {
        path: '',
        name: 'report',
        component: () => import('../views/resourceCenter/report/index.vue'),
      },
      {
        path: 'details',
        name: 'reportDetails',
        component: () => import('../views/introduce/details.vue'),
      },
    ],
  },
  // 资源中心 - 知识分享
  {
    path: '/share',
    component: () => import('../views/resourceCenter/share/share.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
    children: [
      {
        path: '',
        name: 'share',
        component: () => import('../views/resourceCenter/share/index.vue'),
      },
      {
        path: 'details',
        name: 'shareDetails',
        component: () => import('../views/introduce/details.vue'),
      },
    ],
  },
  // 关于我们 - 联系我们
  {
    path: '/contactus',
    name: 'Contactus',
    component: () => import('../views/aboutUs/contactus.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 关于我们 - 岗位招聘
  {
    path: '/recruit',
    name: 'Recruit',
    component: () => import('../views/aboutUs/recruit.vue'),
    meta: {
      keepAlive: false,
    },
  },
  // 服务与解决方案 - 公司案例
  {
    path: '/case',
    name: 'Case',
    component: () => import('../views/service/case.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 服务与解决方案
  {
    path: '/service',
    name: 'Service',
    component: () => import('../views/service/service.vue'),
    meta: {
      keepAlive: false,
    },
  },

  // 公司介绍 - 公司要闻
  {
    path: '/news',
    component: () => import('../views/introduce/news/news.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
    children: [
      {
        path: '',
        name: 'news',
        component: () => import('../views/introduce/news/index.vue'),
      },
      {
        path: 'details',
        name: 'newsDetails',
        component: () => import('../views/introduce/details.vue'),
      },
    ],
  },
  // 道德准则
  {
    path: '/MoralCode',
    name: 'MoralCode',
    component: () => import('../views/moral/index.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 详情页
  {
    path: '/details',
    name: 'Details',
    component: () => import('../views/introduce/details.vue'),
  },

  // 公司介绍 - 企业荣誉
  {
    path: '/honor',
    name: 'Honor',
    component: () => import('../views/introduce/honor.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 公司介绍 - 合作伙伴
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../views/introduce/partner.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 公司介绍 - 管理团队
  {
    path: '/team',
    name: 'Team',
    component: () => import('../views/introduce/team.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 公司介绍 - 公司简介
  {
    path: '/company',
    name: 'Company',
    component: () => import('../views/introduce/company.vue'),
    meta: {
      keepAlive: true, // 需要被缓存
    },
  },
  // 搜索结果
  {
    path: '/res',
    name: 'Res',
    component: () => import('../views/res.vue'),
  },
];

const router = new VueRouter({
  mode: 'hash',
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

export default router;
